import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuList from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { groupselectinputconverter } from "../../../../../../Component/DynamicForm/Fields/GroupSelect";
import DrawerHeader from "../../../../../../Component/Headers/drawerHeader";
import SearchSq from "../../../../../../Component/Material-ui/SearchSq";
import ProfilePictureMedium from "../../../../../../Component/Thumbnail/ProfilePictureMedium";
import { getFormattedImageLink } from "../../../../../../Utils";
import { List, TDTypeConsts } from "../../../../business-configration/commons";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recipientList: [],
      DrawerOpen: false,
      RecipientDrawerOpen: false,
      employeenotice: false,
      isselfassign: false,
      ismanagerassign: false,
      managernotice: false,
      emailsubject: "",
      signatoriesHistory: {
        headers: [
          {
            key: "lettername",
            name: "Letter name",
            style: { textAlign: "left" },
            type: TDTypeConsts.OTHERS,
          },
          {
            key: "categoryname",
            name: "Category",
            type: TDTypeConsts.OTHERS,
          },
          {
            key: "availabilitytypeid",
            name: "Letter type",
            type: TDTypeConsts.LETTER_REQ,
          },
          {
            key: "recepient",
            name: "Recipients",
            type: TDTypeConsts.ASSIGNED_USER,
          },
          {
            key: "imagepath",
            name: "Sender",
            type: TDTypeConsts.SENDER_BY,
          },
          {
            key: "addeddatetime",
            name: "Date of letter",
            type: TDTypeConsts.OTHERS,
          },
        ],
      },
      backupList: [],
      list: [],
    };

    this.searchLetter = this.searchLetter.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
  }

  componentDidMount() {
    const { props } = this;
    console.log("props: ", props);
    this.setState({
      backupList: props.sigDetails.history,
      list: props.sigDetails.history,
    });
  }

  openDrawer({ DrawerOpen }) {
    this.setState({
      DrawerOpen,
    });
  }

  openRecipientDrawer({ RecipientDrawerOpen }) {
    this.setState({
      RecipientDrawerOpen,
    });
  }

  handleClickAway() {
    this.setState({
      DrawerOpen: false,
    });
  }

  closeRecipientDrawer() {
    this.setState({
      RecipientDrawerOpen: false,
    });
  }

  searchLetter(e) {
    const { backupList, list } = this.state;
    const filterList = list.filter(
      (item) =>
        item.lettername.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      list: e.target.value ? filterList : backupList,
    });
  }

  render() {
    const { classes, sigDetails } = this.props;
    const { recipientList } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div className="floatleft">
              <ProfilePictureMedium
                src={getFormattedImageLink(sigDetails.imagepath)}
                className="margin-left-24"
              />
            </div>
            <div className="floatleft margin-left-32">
              <p className="large-text-dark-secondary margin-bottom-8">
                {sigDetails.fullname}
              </p>
              <p className="normal-dark-secondary margin-bottom-8">
                {sigDetails.designationname}
              </p>
              {/* <p className="normal-dark-secondary margin-bottom-8">Active since 28th May, 2017</p> */}
            </div>
          </Grid>
          <Grid item xs={12} md={12} sm={12} className="margin-top-40">
            <div
              className="position-rel"
              style={{ borderBottom: "1px dashed #d9dadb", top: 12 }}
            ></div>
            <div className="text-center">
              <span
                className="position-rel small-dark-disabled"
                style={{ background: "#fff", padding: "0 32px" }}
              >
                Signatory history
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            sm={12}
            justify="flex-end"
            className="display-flex"
          >
            <div className="floatleft margin-right-16">
              <SearchSq
                placeholder="Search letters"
                value={this.state.searchValue}
                onChange={this.searchLetter}
              />
            </div>
            {/* <div
              className="floatleft margin-right-16 filter-icon"
              onClick={() =>
                this.openDrawer({
                  DrawerOpen: true,
                })
              }
            >
              <img src={filterIcon} className="vertical-center"></img>
            </div> */}
          </Grid>
          <Grid item xs={12} md={12} sm={12} className="margin-top-24">
            <List
              showOnlyList
              list={this.state.list}
              permissions={this.state.permissions}
              headers={this.state.signatoriesHistory.headers}
              onEdit={this.onEdit}
              onDelete={this.onDelete}
              module={"signatories-recepients"}
            />
          </Grid>
          <Drawer
            anchor="right"
            open={this.state.RecipientDrawerOpen}
            onClose={() => this.openDrawer({ RecipientDrawerOpen: false })}
            classes={{
              paper: classNames(
                classes.drawerPaper,
                "planner-drawer padding15",
              ),
            }}
          >
            <DrawerHeader
              header="List of recipients"
              isbackarrow={false}
              closeDrawer={this.closeRecipientDrawer}
            />
            <p className="small-dark-seconadry t-bold">Letter name</p>
            <p className="small-dark-seconadry">
              Appraisal Certificate with promotion and increment
            </p>
            <div
              className="thin-scroll selcted-employees-list"
              onScroll={this.handleScroll}
            >
              <div>
                <MenuList>
                  <ListItem className="padding-right-0 padding-top-2 padding-bottom-2">
                    <ListItemText>
                      <p className="extra-small-dark-secondary t-bold">
                        {recipientList &&
                          recipientList[0] &&
                          recipientList[0].fullcount}{" "}
                        employees
                      </p>
                    </ListItemText>
                  </ListItem>
                  {recipientList.map((emp) => (
                    <ListItem className="padding-right-0 padding-top-2 padding-bottom-2">
                      <ListItemText>
                        <p className="small-dark-secondary">
                          {emp.empfullname}
                        </p>
                      </ListItemText>
                    </ListItem>
                  ))}
                </MenuList>
              </div>
            </div>
          </Drawer>
          <Drawer
            anchor="right"
            open={this.state.DrawerOpen}
            onClose={() => this.openDrawer({ DrawerOpen: false })}
            classes={{
              paper: classNames(
                classes.drawerPaper,
                "planner-drawer padding15",
              ),
            }}
          >
            <DrawerHeader
              header="Filter and sort"
              isbackarrow={false}
              closeDrawer={this.handleClickAway}
            />
            <div>
              <DynamicForm
                fields={groupselectinputconverter({
                  label: "Select filter",
                  options: this.state.filterOptions,
                })}
                onChange={() => {}}
              />
            </div>
            <div className="margin-top-24">
              <DynamicForm
                fields={groupselectinputconverter({
                  label: "Select sort",
                  options: this.state.sortOptions,
                })}
                onChange={() => {}}
              />
            </div>
          </Drawer>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(History);
